import { useState } from 'react';
import PersianNumber from "../../utils/PersianNumber/PersianNumber";
import { MdOutlineCurrencyExchange } from "react-icons/md";
import { IoArrowDownOutline, IoArrowUpOutline } from "react-icons/io5";

const TransactionPage = ({
  item,
  type,
  onClose,
  onSubmit,
  statePrice,
  setStatePrice,
  stateWeight,
  setStateWeight,
  stateTotal,
  setStateTotal,
  description,
  setDescription,
  addCommas,
  handlePriceChange,
  handleWeightChange,
  handleTotalChange,
  roleName
}) => {
  const [confirmModal, setConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLocalSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onSubmit();
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-200 rounded-xl p-6 w-full max-w-2xl shadow-xl border-2 border-yellow-700">
        <div className="flex justify-between items-center mb-6 border-b-2 border-yellow-700 pb-4">
          <h2 className="text-2xl font-bold text-gray-800">
            {type === 'buy' ? 'خرید' : 'فروش'} <span className="text-yellow-800">{item.name}</span>
          </h2>
          <button 
            onClick={onClose}
            className="text-yellow-700 hover:text-yellow-900 text-2xl"
          >
            &times;
          </button>
        </div>

        {!confirmModal ? (
          <div className="space-y-6">
            {/* Price Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-lg border border-yellow-700">
                <label className="block text-yellow-800 font-medium mb-2">
                  {item.tag === "S" ? "قیمت" : "مظنه"} (تومان)
                </label>
                <div className="flex items-center">
                  {roleName === "ADMIN" && item[`${type}_price`] !== -1 && (
                    <button
                      className="text-yellow-700 hover:text-yellow-900 ml-2"
                      onClick={() => {
                        const newPrice = parseInt(statePrice || 0) + 1;
                        setStatePrice(newPrice);
                      }}
                    >
                      <IoArrowUpOutline size={20} />
                    </button>
                  )}
                  <input
                    type="text"
                    value={statePrice === -1 ? "" : addCommas(statePrice)}
                    onChange={(e) => handlePriceChange(item, e)}
                    className="w-full bg-gray-100 text-gray-800 p-2 rounded text-left border border-yellow-700"
                    style={{ direction: "ltr" }}
                  />
                  {roleName === "ADMIN" && item[`${type}_price`] !== -1 && (
                    <button
                      className="text-yellow-700 hover:text-yellow-900 mr-2"
                      onClick={() => {
                        const newPrice = Math.max(parseInt(statePrice || 0) - 1, 0);
                        setStatePrice(newPrice);
                      }}
                    >
                      <IoArrowDownOutline size={20} />
                    </button>
                  )}
                </div>
              </div>

              {/* Weight Section */}
              <div className="bg-white p-4 rounded-lg border border-yellow-700">
                <label className="block text-yellow-800 font-medium mb-2">
                  {item.tag === "S" ? "تعداد" : "مقدار (گرم)"}
                </label>
                <input
                  type="text"
                  value={stateWeight}
                  onChange={(e) => handleWeightChange(item, e)}
                  className="w-full bg-gray-100 text-gray-800 p-2 rounded border border-yellow-700"
                />
              </div>

              {/* Total Section */}
              <div className="bg-white p-4 rounded-lg border border-yellow-700">
                <label className="block text-yellow-800 font-medium mb-2">جمع کل (تومان)</label>
                <input
                  type="text"
                  value={addCommas(stateTotal)}
                  readOnly
                  className="w-full bg-gray-100 text-gray-800 p-2 rounded text-left border border-yellow-700"
                  style={{ direction: "ltr" }}
                />
              </div>
            </div>

            {/* Description Section */}
            <div className="bg-white p-4 rounded-lg border border-yellow-700">
              <label className="block text-yellow-800 font-medium mb-2">توضیحات</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full bg-gray-100 text-gray-800 p-2 rounded border border-yellow-700"
                rows="2"
              />
            </div>

            <div className="flex justify-end space-x-3 mt-6">
              <button 
                onClick={onClose}
                className="px-6 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-300 transition font-medium border border-yellow-700"
              >
                لغو
              </button>
              <button
                onClick={() => setConfirmModal(true)}
                disabled={!statePrice || !stateWeight}
                className={`px-6 py-2 rounded-lg text-white hover:opacity-90 transition font-medium ${
                  type === 'buy' ? 'bg-yellow-700 hover:bg-yellow-800' : 'bg-yellow-600 hover:bg-yellow-700'
                } ${(!statePrice || !stateWeight) ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                ادامه
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg border-2 border-yellow-700">
              <h3 className="text-xl font-bold text-yellow-800 mb-4 border-b-2 border-yellow-700 pb-2">تأیید نهایی تراکنش</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-800">
                <div>
                  <p className="font-medium text-yellow-700">نوع تراکنش:</p>
                  <p className={type === 'buy' ? 'text-yellow-800 font-bold' : 'text-yellow-700 font-bold'}>
                    {type === 'buy' ? 'خرید' : 'فروش'}
                  </p>
                </div>
                <div>
                  <p className="font-medium text-yellow-700">محصول:</p>
                  <p className="font-bold">{item.name}</p>
                </div>
                <div>
                  <p className="font-medium text-yellow-700">{item.tag === "S" ? "قیمت" : "مظنه"}:</p>
                  <p className="font-bold"><PersianNumber value={statePrice} thousandSeparator="," /> تومان</p>
                </div>
                <div>
                  <p className="font-medium text-yellow-700">{item.tag === "S" ? "تعداد" : "مقدار"}:</p>
                  <p className="font-bold"><PersianNumber value={stateWeight} thousandSeparator="," /></p>
                </div>
                <div>
                  <p className="font-medium text-yellow-700">جمع کل:</p>
                  <p className="font-bold"><PersianNumber value={stateTotal} thousandSeparator="," /> تومان</p>
                </div>
                <div>
                  <p className="font-medium text-yellow-700">توضیحات:</p>
                  <p className="font-bold truncate">{description || '-'}</p>
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center pt-4">
              <button 
                onClick={() => setConfirmModal(false)}
                className="px-6 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-300 transition font-medium border border-yellow-700"
              >
                بازگشت
              </button>
              <button
                onClick={handleLocalSubmit}
                disabled={isSubmitting}
                className={`px-6 py-2 rounded-lg text-white flex items-center font-medium ${
                  type === 'buy' ? 'bg-yellow-700 hover:bg-yellow-800' : 'bg-yellow-600 hover:bg-yellow-700'
                } hover:opacity-90 transition ${isSubmitting ? 'opacity-70' : ''}`}
              >
                {isSubmitting ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    در حال ثبت...
                  </>
                ) : (
                  <>
                    <MdOutlineCurrencyExchange className="ml-2" />
                    تأیید و ثبت نهایی
                  </>
                )}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionPage;